import {
  type SearchClientsRequest,
  type SearchClientContactsRequest,
  type GetClientRequest,
  GetByIdClientContactRequest,
} from '@trukt/tms-api/ClientServices';
import { createKey } from './createKey';

const contactKeyHandler = createKey('client-contact');
const clientKeyHandler = createKey('client');

const ClientContactServiceKeys = {
  key: contactKeyHandler.key,
  search: contactKeyHandler.createMethod<SearchClientContactsRequest>(),
  getById: contactKeyHandler.createMethod<GetByIdClientContactRequest>(),
};

export const ClientServiceKeys = {
  key: clientKeyHandler.key,
  contact: ClientContactServiceKeys,
  search: clientKeyHandler.createMethod<SearchClientsRequest>(),
  getById: clientKeyHandler.createMethod<GetClientRequest>(),
};
